'use client';

import { InlinePromoBanner } from '@flipster/features/src/banners/inline-promo-banner';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { MainEvent } from '@flipster/utils/segment/events/main';

export const TradFiPromoBanner = () => (
  <InlinePromoBanner
    variant='MARKET'
    onView={(banner) =>
      segment.track(MainEvent.MarketPromotionBannerView, {
        segment_id: banner.segmentId,
        image_name: banner.title,
      })
    }
    onClickCta={(banner) =>
      segment.track(MainEvent.MarketPromotionBannerClick, {
        segment_id: banner.segmentId,
        image_name: banner.title,
        button_url: banner.webLink ?? '',
      })
    }
    classNames={{
      root: css({ mx: { base: 16, tablet: 0 }, mb: { base: 16, tablet: 80 } }),
      card: hstack({ gap: 20, minH: 72, px: 24, py: 12, rounded: 16 }),
    }}
  />
);
